import { render, staticRenderFns } from "./VDial.vue?vue&type=template&id=64b1a191&"
import script from "./VDial.vue?vue&type=script&lang=js&"
export * from "./VDial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports